import { StartClient } from '@tanstack/react-start/client'
import { StrictMode } from 'react'
import { hydrateRoot } from 'react-dom/client'

import { sentry } from '@/lib/sentry'

sentry.init()

hydrateRoot(
	document,
	<StrictMode>
		<StartClient />
	</StrictMode>,
)
